import { actionCreators } from "../reducers/native";
import { AppDispatch } from "../../index";

export function resumed() {
    return (dispatch: AppDispatch) => {
        dispatch(actionCreators.resumed());
    };
}
